import _get from 'lodash/get';

export default function isVisualSearchEnabled(user) {
  if (!user) return false;
  const enableCLIPEmbeddingsSearch = _get(user, 'team.settings.search.enableCLIPEmbeddingsSearch', false);
  const enableTextEmbeddingsSearch = _get(user, 'team.settings.search.enableEmbeddingsSearch', false);

  return enableCLIPEmbeddingsSearch || enableTextEmbeddingsSearch;
}
